import React from 'react';

function Project({title="", ico="", bg="", url="", children}){
	return (
		<div className='project' style={{background: bg}}>
			<img className ="preview-img" src={ico}></img>
			<div className='project-title'>
				<a href={url} target='_blank'>{title}</a>
			</div>
			<div className='project-info'>
				{children}
			</div>
		</div>
	)
}

function Projects({visible, wasVisible}){
	const visibility = !visible && visible == wasVisible ? "hidden" : "visible";
	return (
		<>
			<div className="top-left" style={{visibility}}>
				<div className='projects' style={{opacity: visible ? 1 : 0}}>
					<h1 className='marginless'>My Projects</h1>
					<Project title='DMart'
						ico='./dmart.png'
						bg="#4008"
						url='https://play.google.com/store/apps/details?id=com.coolgames.dmart'>
						A school project in Unity with me as a developer and my sister as an artist.
					</Project>
					<Project title='Card Maker'
						ico='./cardMaker.png'
						bg="#5058"
						url='/evadesio_tools'>
						A html canvas app (JS) made for <a href='https://evades.io/'>evades.io</a> community to ease the process of creating tournament and event cards 
					</Project>
					<Project title='Depuresu!'
						ico='/img/depik.svg'
						bg="#5058"
						url='/'>
						Check more of my other projects on my newly created website! 
					</Project>
				</div>
			</div>
		</>
	)
}

export default Projects;